import { render, staticRenderFns } from "./Tcm.vue?vue&type=template&id=6bc63d59&scoped=true"
import script from "./Tcm.vue?vue&type=script&lang=js"
export * from "./Tcm.vue?vue&type=script&lang=js"
import style0 from "./Tcm.vue?vue&type=style&index=0&id=6bc63d59&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc63d59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bc63d59')) {
      api.createRecord('6bc63d59', component.options)
    } else {
      api.reload('6bc63d59', component.options)
    }
    module.hot.accept("./Tcm.vue?vue&type=template&id=6bc63d59&scoped=true", function () {
      api.rerender('6bc63d59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TCMRx/comp/Tcm.vue"
export default component.exports